export class SizeUtility {
  breakpoints = {
    sm: 36,
    md: 48,
    lg: 62,
  };

  isScreenGtLg() {
    return this.getWindowWidthInRem() > this.breakpoints.lg;
  }

  isScreenGtMd() {
    return this.getWindowWidthInRem() > this.breakpoints.md;
  }

  isScreenGtSm() {
    return this.getWindowWidthInRem() > this.breakpoints.sm;
  }

  getWindowWidthInRem() {
    return (
      window.innerWidth / parseFloat(getComputedStyle(document.querySelector('body'))['font-size'])
    );
  }
}

export default new SizeUtility();
